export default {
  // Page title
  'page.title': 'タイマー',

  // Popular timers
  'popular.title': '人気のタイマー',
  'popular.10s': '10秒タイマー',
  'popular.20s': '20秒タイマー',
  'popular.30s': '30秒タイマー',
  'popular.40s': '40秒タイマー',
  'popular.50s': '50秒タイマー',
  'popular.90s': '1.5分タイマー',
  'popular.2minute': '2分タイマー',
  'popular.3minute': '3分タイマー',
  'popular.5minute': '5分タイマー',
  'popular.10minute': '10分タイマー',
  'popular.15minute': '15分タイマー',
  'popular.30minute': '30分タイマー',
  'popular.60minute': '60分タイマー',
  'popular.1hour': '1時間タイマー',
  'popular.10hour': '10時間タイマー',
  'popular.24hour': '24時間タイマー',
  'popular.48hour': '48時間タイマー',

  // How to use
  'howto.title': 'タイマーの設定方法',
  'howto.titleMinutes': '{{minutes}}分タイマーの設定方法',
  'howto.titleSeconds': '{{seconds}}秒タイマーの設定方法',
  'howto.titleHour': '{{hours}}時間タイマーの設定方法',
  'howto.titleHours': '{{hours}}時間タイマーの設定方法',
  'howto.step1': '⚙️ 時間を設定する:時間または分の数字をクリックして直接編集できます。最大23時間59分まで、どんなタスクにも設定可能です。',
  'howto.step2': '⚡ クイック時間調整:便利なクイック追加ボタンで、30秒、1分、5分、10分、30分を瞬時にタイマーに追加できます。',
  'howto.step3': '▶️ 開始とコントロール:「開始」をクリックしてカウントダウンを始めます。いつでも一時停止して休憩を取り、準備ができたら再開、またはリセットして最初から始められます。',
  'howto.step4': '🔔 通知を受け取る:時間が経過すると、デスクトップ通知とカスタマイズ可能なサウンドアラートでお知らせします。右上隅でサウンドのオン/オフを切り替えられます。',
  'howto.step5': '🖥️ フルスクリーンモード:フルスクリーンボタンをクリックして集中モードに - プレゼンテーション、瞑想、集中作業セッションに最適です。',
  'howto.step6': '📱 どこでも利用可能:デスクトップ、タブレット、モバイルなど、あらゆるデバイスで使用できます。ダウンロード不要、ブラウザで直接動作します。',

  // User review submission
  'reviewSubmission.title': 'ご感想をシェアする',
  'reviewSubmission.subtitle': 'あなたの体験を共有して、他の方がこのタイマーを見つける手助けをしてください',
  'reviewSubmission.ratingLabel': 'ご評価ください',
  'reviewSubmission.commentLabel': 'レビュー(任意)',
  'reviewSubmission.commentPlaceholder': 'このタイマーが生産性向上、料理、勉強、その他の活動でどのように役立ったかお聞かせください...',
  'reviewSubmission.nameLabel': 'お名前(任意)',
  'reviewSubmission.namePlaceholder': 'お名前の表示方法を教えてください',
  'reviewSubmission.submitButton': 'レビューを送信する',
  'reviewSubmission.thankYou': 'レビューをお寄せいただきありがとうございます!',
  'reviewSubmission.thankYouMessage': 'あなたのフィードバックは私たちの改善に役立ち、他の方がこのタイマーを見つける手助けとなります。',
  'reviewSubmission.error': '送信前に評価を選択してください。',

  // User reviews
  'reviews.title': 'ユーザーの声',
  'reviews.newReview': '新しいレビュー',
  'reviews.mikeZhang': '生産性の大変革!ポモドーロテクニックとこのタイマーのおかげで論文を完成できました。洗練されたインターフェース、気が散ることがありません。',
  'reviews.lisaLee': 'キッチンタイマーに完璧!もう卵を焦がすことはありません。サウンドアラートは十分な音量で、不快ではありません。高齢の母も大変気に入っています。',
  'reviews.johnDeveloper': '最高のコーディング休憩タイマー!プリセットボタンで大幅な時間節約。目の疲労を防ぎ、スプリント中の集中力を保ちます。',
  'reviews.msChen': '教室運営が劇的に変わりました!生徒たちが時間制限のある活動を実際に楽しんでいます。視覚的なカウントダウンで全員が集中します。',
  'reviews.fitnessPro': 'HIITワークアウトに革命的!正確なタイミング、汗をかいた手でも簡単に操作できます。クライアントたちはフルスクリーンモードを大変気に入っています。',
  'reviews.sarahMarketer': '会議の効率が40%向上しました!もう終わりのない議論はありません。時間制限により決断を促し、全員が集中し続けます。',
  'reviews.tomChef': 'レストランのキッチンに不可欠!パスタ、ステーキ、ソース - 毎回完璧なタイミング。複数のクイック追加ボタンは天才的です。',
  'reviews.amyStudent': '勉強の大変革!先延ばし癖を管理可能な時間に分けて打破します。この方法でC評価からA評価になりました。',
  'reviews.davidWriter': 'ライターズブロックが治りました!15分の執筆スプリントが勢いを生み出します。このタイマーのおかげで今月3本の記事を公開できました。',
  'reviews.rachelTherapist': 'クライアントとの瞑想セッションに完璧。穏やかなアラートが平和な雰囲気を壊しません。非常にプロフェッショナルです。',
  // Preset timer specific reviews
  'reviews.managerZhang': 'オフィスワークに必須!お茶の抽出や会議の休憩に最適。洗練されたインターフェースで仕事の邪魔になりません。',
  'reviews.mrsLi': '完璧な卵タイマー!3分の半熟卵が毎回完璧に仕上がります。サウンドアラートがとても親切で、卵を焦がすことがありません。',
  'reviews.programmerWang': 'コーディング休憩中の目の体操に必須。3分は目の筋肉をリラックスさせるのにちょうど良い時間。視力保護に最適!',

  // Use cases
  'useCases.title': '{{minutes}}分タイマーの活用例',
  'useCases.titleSeconds': '{{seconds}}秒タイマーの活用例',
  'useCases.titleHours': '{{hours}}時間タイマーの活用例',

  // Page titles
  'pageTitle': '{{minutes}}分タイマー',
  'pageTitleSeconds': '{{seconds}}秒タイマー',
  'pageTitleHour': '{{hours}}時間タイマー',
  'pageTitleHours': '{{hours}}時間タイマー',

  // User names
  'user.mikeZhang': 'マイク・チャン',
  'user.lisaLee': 'リサ・リー',
  'user.johnDeveloper': 'ジョン開発者',
  'user.msChen': 'チェン先生',
  'user.fitnessPro': 'フィットネスプロ',
  'user.sarahMarketer': 'サラ・マーケター',
  'user.tomChef': 'トム・シェフ',
  'user.amyStudent': 'エイミー学生',
  'user.davidWriter': 'デビッド・ライター',
  'user.rachelTherapist': 'レイチェル・セラピスト',
  // Preset timer specific users
  'user.managerZhang': 'チャン部長',
  'user.mrsLi': 'リー夫人',
  'user.programmerWang': 'ワンプログラマー',

  // Use cases
  'useCases.quickBreak.title': 'クイック休憩',
  'useCases.quickBreak.desc': '作業セッション間の短い休憩で、気分をリフレッシュし、燃え尽き症候群を防ぎます',
  'useCases.eyeCare.title': '目のケアリマインダー',
  'useCases.eyeCare.desc': '20-20-20ルールに従いましょう:20分ごとに、20フィート(約6メートル)先を20秒間見つめます',
  'useCases.teaBrewing.title': 'お茶の抽出',
  'useCases.teaBrewing.desc': '緑茶(3分)、紅茶(5分)、ハーブブレンドの完璧な抽出時間',
  'useCases.lightExercise.title': '軽い運動',
  'useCases.lightExercise.desc': 'オフィスでのストレッチ、デスクヨガ、座りっぱなし生活対策の簡単な運動',
  'useCases.meditation.title': 'マインドフルネスと瞑想',
  'useCases.meditation.desc': 'ガイド付き呼吸法、マインドフルネス実践、ストレス解消瞑想',
  'useCases.softBoiledEggs.title': '料理タイマー',
  'useCases.softBoiledEggs.desc': '半熟卵(5分)、パスタの茹で時間、あらゆるキッチン作業の完璧なタイミング',
  'useCases.quickReading.title': '集中読書',
  'useCases.quickReading.desc': '本、記事、学習資料のための集中読書セッション',
  'useCases.phoneCall.title': '通話・会議タイマー',
  'useCases.phoneCall.desc': '電話を予定通りに進める、会議時間を制限する、プレゼンテーションの時間を計る',
  'useCases.focusedWork.title': 'ポモドーロ作業セッション',
  'useCases.focusedWork.desc': 'クラシックなポモドーロテクニック - 25分間の集中作業の後に休憩',
  'useCases.exercise.title': 'ワークアウトとトレーニング',
  'useCases.exercise.desc': '高強度インターバル、サーキットトレーニング、特定の運動時間',
  // 15-minute specific
  'useCases.shortMeeting.title': 'スタンドアップミーティング',
  'useCases.shortMeeting.desc': 'クイックチーム更新、デイリースタンドアップ、簡潔な協力的議論',
  'useCases.powerNap.title': 'パワーナップ',
  'useCases.powerNap.desc': '眠気を残さずエネルギーをチャージできる最適な昼寝時間',
  'useCases.learning.title': '学習セッション',
  'useCases.learning.desc': '言語練習、スキルチュートリアル、教育ビデオセグメント',
  'useCases.creativity.title': 'クリエイティブスプリント',
  'useCases.creativity.desc': 'ブレインストーミングセッション、執筆スプリント、芸術的練習',
  // 30-minute specific
  'useCases.deepWork.title': 'ディープワークセッション',
  'useCases.deepWork.desc': '複雑なタスクのための中断を最小限に抑えた長時間の集中作業',
  'useCases.workout.title': '完全ワークアウト',
  'useCases.workout.desc': 'フルエクササイズルーチン、ヨガセッション、構造化されたトレーニングプログラム',
  'useCases.study.title': '学習ブロック',
  'useCases.study.desc': '試験、研究、スキル開発のための集中学習セッション',
  'useCases.presentation.title': 'プレゼンテーション練習',
  'useCases.presentation.desc': 'スピーチのリハーサル、ピッチの練習、プレゼンテーションの時間配分',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'アレックス・オフィス',
  'user.developerSarah': 'サラ開発者',
  'user.designerMike': 'マイク・デザイン',
  'reviews.officeWorkerAlex': '会議の合間のクイック休憩に完璧!たった1分のストレッチと集中で大きな違いが生まれます。',
  'reviews.developerSarah': '20-20-20ルールに最適 - 20分ごとに20フィート先を1分間見ます。目がとても楽になりました!',
  'reviews.designerMike': '集中的なデザイン作業中のマイクロブレイクに使っています。短時間ですが、燃え尽き症候群防止に効果的です。',

  // 3-minute timer users
  'user.teaLoverEmily': 'エミリー・紅茶',
  'user.yogatrainerJohn': 'ジョン・ヨガ',
  'user.busyMomLisa': 'リサ・ママ',
  'reviews.teaLoverEmily': '緑茶に完璧なタイミング!3分で苦味のない完璧な風味が楽しめます。サウンドアラートが大好きです!',
  'reviews.yogatrainerJohn': 'クライアントとの簡単な呼吸法に使っています。3分は落ち着きのあるセッションにちょうど良いです。',
  'reviews.busyMomLisa': '子供たちの歯磨きタイムに最適。カウントダウンを実際に楽しんでいます!',

  // 5-minute timer users
  'user.meditatorZen': '禅マスター',
  'user.chefTony': 'トニー・シェフ',
  'user.runnerMia': 'ミア・ランナー',
  'reviews.meditatorZen': '初心者の瞑想に完璧。5分は管理しやすく、マインドフルネス実践に効果的です。',
  'reviews.chefTony': 'キッチンに必須!毎回完璧な半熟卵のタイミングです。プロフェッショナルで信頼できます。',
  'reviews.runnerMia': 'ラン後のストレッチに使っています。5分で回復ルーチンをスキップしないように確保できます!',

  // 10-minute timer users
  'user.studentDavid': 'デビッド学生',
  'user.managerRachel': 'レイチェル部長',
  'user.writerJames': 'ジェームズ・ライター',
  'reviews.studentDavid': '学習休憩に最適!10分は勢いを失わずに精神的リセットができる完璧な時間です。',
  'reviews.managerRachel': '集中読書セッションに使っています。10分間の中断のない読書は本当に効果的です!',
  'reviews.writerJames': '時間制限のある執筆スプリントに完璧。10分間のプレッシャーがライターズブロックを克服するのに役立ちます。',

  // 15-minute timer users
  'user.consultantAmy': 'エイミー・コンサルタント',
  'user.teacherBen': 'ベン先生',
  'user.freelancerSophie': 'ソフィー・フリーランサー',
  'reviews.consultantAmy': 'クイッククライアント通話とスタンドアップミーティングに理想的。議論を集中的かつ生産的に保ちます。',
  'reviews.teacherBen': '教室活動とグループワークに使っています。時間制限により生徒たちが集中し続けます。',
  'reviews.freelancerSophie': '完璧なポモドーロセッション!15分間の集中作業の後に休憩を取ることで、一日中生産的でいられます。',

  // 30-minute timer users
  'user.executiveRobert': 'ロバート重役',
  'user.fitnessCoachMaya': 'マヤ・フィットネス',
  'user.artistOlivia': 'オリビア・アーティスト',
  'reviews.executiveRobert': 'ディープワークセッションに優れています。30分は圧倒的な負担なく意義のある進歩を可能にします。',
  'reviews.fitnessCoachMaya': '完全なワークアウトサーキットに完璧。クライアントたちはさまざまなエクササイズの構造化されたタイミングを気に入っています。',
  'reviews.artistOlivia': 'クリエイティブセッションに最適。30分はフロー状態に入り、意義のあるものを創造するのに十分な時間です。',
};
